import { ReturnAssessmentDefinitionSchema } from "@redotech/redo-model/return-assessments/assessment-schemas";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAssessmentDefinition = {
  name: "getAssessmentDefinition" as const,
  input: z.object({ definitionId: zExt.objectId() }),
  output: z.object({ definition: ReturnAssessmentDefinitionSchema.nullable() }),
};
